import { createSelector } from 'reselect';

const stateAuthSelector = (state) => state.auth;

export const authSelector = createSelector(
    [stateAuthSelector],
    (auth) => {
        return { ...auth };
    }
);